<template>
  <div class="wrap">
    <h3 class="title">用户服务协议</h3>
    <p>
      本平台---海科商户通，是北京海科融通支付服务有限公司（以下简称“本公司”）负责运营的，主要为平台商户提供银行卡收单相关服务，以及为会员代理平台推介产品提供相关服务,以下简称“平台或公司”。
    </p>
    <p>
      <span class="weight"
        >为了保障您的权益，请于注册或使用本服务前，仔细阅读并完全理解本服务条款的全部内容，其中用粗字体予以标注的，是与您的权益有或可能具有重大关系，及对本公司具有或可能具有免责或限制责任的条款，请您特别注意。当您操作点击“同意”按钮或进行类似表示同意的操作，以及以其他方式使用平台服务时，本服务协议即生效，构成对双方具有约束力的法律文件。如您不同意本服务协议或其中任何条款约定，您应不再进行下一步或停止注册程序。</span
      >
    </p>
    <p>
      您只有成功注册成为本平台用户后，才能使用本平台提供的相关用户服务。您认可，注册为平台用户后，根据不同产品的需求，需通过相对应的资格审核后才享有使用相关产品的权利。
    </p>
    <p><span class="weight">第一条 用户的主体资格</span></p>
    <p>
      <span class="weight"
        >1、本平台只接受具有合法运营资格的机构及持有有效身份证件的18周岁以上的具有完全民事行为能力和权利能力的自然人成为平台用户。</span
      >如您不具备上述资格，您应立即停止在本平台的注册程序、停止使用本平台服务；同时，本平台有权随时终止您的注册进程及服务、注销您的账户（本协议提及的“注销账户”“取消用户资格”“终止服务”等词语包含终止本协议及相关网签协议的涵义），您应对您的注册与使用给本平台带来的损失承担赔偿责任，如您为限制民事行为能力或无民事行为能力的自然人，您的监护人应承担相关责任。
    </p>
    <p>
      2、在注册时和使用本平台服务的所有期间内，您应提供您自身的真实、最新、有效及完整的信息资料并保证提交的所有资料和信息，在上述期间具有持续的有效性及安全性，持续具有用户资格，否则本平台有权拒绝您的注册申请或终止服务，如造成本平台或其他第三方损失的，您应当承担赔偿责任。
    </p>
    <p>
      <span class="weight"
        >3、您授权本平台在为您业务办理的过程中自行或委托第三方对您进行身份认证、银行卡鉴权等相关认证服务。</span
      >
    </p>
    <p><span class="weight">第二条 服务内容</span></p>
    <p>（一）商户服务</p>
    <p>
      1、本平台专注于竭诚为您提供受理银行卡收单业务相关的支持服务。您可在平台进行银行卡收单服务所涉及的商户绑定、交易查询、结算查询、终端流量查询等服务。
    </p>
    <p>（二）办卡服务</p>
    <p>
      1、本平台为平台会员提供信用卡的办理与推介服务，您可以申请办理信用卡，也可以为产品方推荐客户。<span
        class="weight"
        >该等产品由第三方提供，非本平台、本公司自营产品。</span
      >
    </p>
    <p>
      <span class="weight"
        >2、本办卡服务的业务规则，包括但不限于您申请办理与核发信用卡的标准，您推广办理信用卡的业务政策均由产品方制定。如您使用有关产品，其产品规则、服务内容等请详见各产品、平台的相关协议内容或页面提示，本平台不对其产品的合法合规性、真实性及履约情况做任何承诺与保证。</span
      >
    </p>
    <p>
      <span class="weight"
        >3、本平台集成各产品方的相关产品用于展示和推介，从而促成用户使用该产品。本平台仅提供中介服务，不对您或各产品、平台做任何背书和承诺。</span
      >
    </p>
    <p>（三）贷款服务</p>
    <p>
      1、本平台为平台会员第三方小额贷款产品推介服务。您可以向产品方申请小额贷款，也可以为产品方推荐客户。<span
        class="weight"
        >该等产品由第三方提供，非本平台、本公司自营产品。</span
      >
    </p>
    <p>
      <span class="weight"
        >2、本贷款服务的业务规则，包括但不限于您申请小额贷款的审核标准，借款利率与手续费标准，还款期限与方式，您推广用户的业务政策均由产品方制定。如您使用有关产品，其产品规则、服务内容等请详见各产品、平台的相关协议内容或页面提示，本平台不对其产品的合法合规性、真实性及履约情况做承担任何承诺与保证。</span
      >
    </p>
    <p>
      <span class="weight"
        >3、本平台集成各产品方的相关产品用于展示和推介，从而促成用户使用该产品。本平台仅提供中介服务，不对您或各产品、平台做任何背书和承诺。</span
      >
    </p>
    <p>（四）个体办理业务</p>
    <p>
      本平台集成第三方代办公司为平台会员提供办理个体工商户证照等相关服务（以下简称“个体办理”）。
    </p>
    <p>
      <span class="weight"
        >有关个体办理的服务内容、办理时效、服务费用等因设立区域的不同而不同，具体内容请您仔细阅读与甄选适合您的选项。</span
      >
    </p>
    <p>
      <span class="weight"
        >以上提及的各服务类型与服务内容等具体情况以本平台实际提供的服务内容为准。</span
      >
    </p>
    <p>第三条 平台使用须知</p>
    <p>
      1、您成功注册成为用户后，可通过您设置的用户名和密码登录本平台，具体服务内容以本平台公布为准。
    </p>
    <p>
      <span class="weight"
        >2、如您为企业用户，您授权指定员工为您账号的管理人，全权代表您履行本协议项下全部事宜。授权期限从本协议生效之日起直至本协议终止/解除之日止，但您另行向平台书面通知变更的除外。您确认，该被授权人的行为视同您公司行为，其法律后果由您承担。</span
      >如发现他人未经授权使用您的平台账号和密码，您应立即通知平台；平台经营主体将协助您冻结账号、更改密码或进行其他安全设置；您理解平台经营主体对您的请求采取行动需要合理时间，平台经营主体对在采取行动前已经产生的以及由您引发的后果（包括但不限于您的任何损失）不承担任何责任。
    </p>
    <p>
      3、您在注册时向本平台提交的手机号码、电子邮箱、用户名、密码及安全问题答案等是您在本平台的识别信息。您注册成功后应妥善保管上述识别信息，不得将其转让、授权第三方使用或泄露，如果本平台发现同一账户在同一时间内被多人同时登陆使用，或类似风控规则判定存在账户风险的，本平台有权限制该用户访问直至取消用户资格，并不承认任何赔偿责任。同时，<span
        class="weight"
        >您确认，使用您的用户名和密码等登录本平台后在本平台的一切行为均视为代表您本方意志并由您承担相应的法律后果，不得以非本方操作为由拒绝认可其法律效力。</span
      >
    </p>
    <p>
      4、若您发现有他人冒用或盗用您的用户名及密码或任何其他未经合法授权之信息登录时，应立即以有效方式通知本平台，要求暂停相关服务。同时，您理解本平台对您的请求采取行动需要合理期限，而在本平台采取实际行动之前，您应承担任何未经授权人士使用此服务或此服务被用作未经授权用途的不利后果并对其负责，本平台对已执行的指令及所导致的您及任何第三方的损失不承担任何责任。
    </p>
    <p>
      <span class="weight"
        >5、您保证合法使用本平台提供的服务，未经本平台事先书面授权，不使用任何非法手段擅自进入本平台未公开的系统。</span
      >
    </p>
    <p>
      <span class="weight"
        >6、您不得利用本平台从事任何违反中国法律、法规、行业规定或侵犯国家利益、社会利益、他人合法权益的活动；不得发送、公布或展示违反中国法律、法规及本协议的内容，任何垃圾、广告推销内容。本平台在发现您从事该等活动时，有权不经通知而立即停止您对本平台的全部或部分功能的使用，删除上述违法内容，注销您的账户并不予任何赔偿。</span
      >
    </p>
    <p>
      <span class="weight"
        >7、在您使用本平台时，您认可本平台或本平台合法委托的第三方可以通过短信、电子邮件、微信等电子形式向您发送关于本平台或者其他方的广告，或者在任何形式的通知中附带广告或者含有广告的链接。您认可本平台、本公司通过电话营销的形式向您推荐平台相关业务。</span
      >
    </p>
    <p>
      <span class="weight"
        >8、您授权本平台委托第三方进行网签协议的签署，并由第三方进行网签协议的存证工作您认可电子签章记载时间为网签协议签署时间，且认可经过电子签章的网签协议的完全效力，不得以非纸质协议或协议可被篡改等为理由否认其效力。</span
      >
    </p>
    <p>第四条 用户信息的合理使用与保护</p>
    <p>
      <span class="weight"
        >1、为您提供平台服务之必须，以及更好地为您提供服务，您同意本平台在业务运营中收集、储存、合理使用您的用户信息，包括但不限于您自行提供的，本平台在您使用过程中自行合法收集取得的，以及向第三方合法收集的信息。具体内容请查看平台《隐私政策》。</span
      >
    </p>
    <p>
      2、平台将采取技术措施和其他必要措施，确保用户个人信息安全，防止在本服务中收集的用户个人信息泄露、毁损或丢失。在发生前述情形或发现存在发生前述情形的可能时，平台将及时采取补救措施并告知用户，如您发现存在前述情形亦需立即与平台联系。
    </p>
    <p><span class="weight">第五条 承诺和保证</span></p>
    <p>
      <span class="weight"
        >1、您作为本平台用户应保证严格遵守中国现行法律、法规、政府规章及其他应该遵守的规范性文件，不从事危害国家安全、洗钱、套现、传销等任何违法活动或者其他有违社会公共利益、公共道德、公序良俗的行为。您作为平台用户，应保证您经营活动和经营范围的合法性。同时，您将不会利用本服务从事侵害本公司、他人合法权益之行为，以及进行任何违法或不正当的活动，否则本公司有权拒绝提供服务，且您应承担因此产生的一切责任；本公司、本公司雇员或任何第三方合法权益因此受损的，您应承担损害赔偿责任。具体要求如下：</span
      >
    </p>
    <p>
      <span class="weight"
        >（1）严格遵守国家法律法规、监管部门规定以及公司管理要求，在本公司的业务范围内合法合规地开展业务；</span
      >
    </p>
    <p><span class="weight">（2）禁止欺诈、虚假、不准确或存在误导性的交易行为；</span></p>
    <p>
      <span class="weight">
        （3）禁止从事不法交易行为，如洗钱、贩卖枪支、毒品、禁药、盗版软件、黄色淫秽物品以及其他本平台认为不得使用本服务进行交易的物品与服务等；</span
      >
    </p>
    <p>
      <span class="weight">
        （4）禁止非法使用他人银行账号（包括信用卡账号）或无效银行账号（包括信用卡账号）；</span
      >
    </p>
    <p>
      <span class="weight">
        （5）禁止出租、出借、出售支付受理终端（含条码支付辅助受理终端）、收款条码和收单结算账户；</span
      >
    </p>
    <p>
      <span class="weight">
        （6）全部行为符合《中华人民共和国广告法》及相关规定，真实、健康地开展业务，不得含有虚假或者引人误解的内容，不得欺骗、误导他人，且不得使用含有“套现”“透支”“薅羊毛”等违法违规的宣传内容；</span
      >
    </p>
    <p>
      <span class="weight">
        （7）全部行为符合《中华人民共和国反不正当竞争法》《中华人民共和国消费者权益保护法》及相关规定，禁止采取扰乱市场竞争秩序，损害其他经营者或者消费者的合法权益的行为；</span
      >
    </p>
    <p>
      <span class="weight"
        >（8）时刻维护本公司良好声誉与合法权益，且不得超过本公司授权范围开展业务；</span
      >
    </p>
    <p>
      <span class="weight">
        （9）严格按照产品活动说明进行推荐，不得推荐不符合要求的用户或擅自、合谋套取活动奖励与报酬；</span
      >
    </p>
    <p>
      <span class="weight">
        （10）针对支付服务禁止设点公开推广或网络公开推广；禁止发展下级、多级开展业务，拉人头，收取入会费等违法违规行为。</span
      >
    </p>
    <p>
      <span class="weight">
        （11）严禁侵犯他人著作权、商标权、专利权、商业秘密等知识产权以及隐私权、名誉权等合法权益；</span
      >
    </p>
    <p><span class="weight">（12）遵守法定、约定之保密义务，禁止滥用个人信息；</span></p>
    <p>
      <span class="weight">（13）遵守使用网络服务的所有网络协议、规则、程序和惯例；</span>
    </p>
    <p>
      <span class="weight">
        （14）禁止其他一切违法、违规、违约等不当行为以及其他本平台有正当理由认为之不适当的行为。</span
      >
    </p>
    <p>
      <span class="weight">
        2、您认可，本公司实时对您使用平台服务的动态进行监督和检查，如发现您有违反国家法律、法规规定、行业规定或本协议约定的，有权立即暂停、终止服务、注销您的账户。</span
      >
    </p>
    <p>
      <span class="weight">
        3、您认可，您给本公司造成损失的，赔偿责任包括但不限于实际损失、行政罚金、律师费、诉讼费、公证费、食宿费，相关损失本公司有权从您的交易净金额及其他服务费中扣除。</span
      >
    </p>
    <p><span class="weight">六、风险提示与免责条款</span></p>
    <p>
      <span class="weight">
        1、平台因以下风险的发生而没有正确执行本协议项下提供平台服务的义务，不应视为平台违约，平台不承担任何责任：</span
      >
    </p>
    <p>
      <span class="weight">
        （1）信息泄露风险：因您的信息及使用者个人信息和资料被不法分子窃取、泄露的风险以及由此带来的隐私、生活受到干扰、侵犯的风险；</span
      >
    </p>
    <p>
      <span class="weight">
        （2）敏感个人信息泄露风险：一旦泄露或者非法使用，有导致您人格尊严受到侵害或者人身、财产安全受到危害的风险；</span
      >
    </p>
    <p>
      <span class="weight">
        （3）服务中断风险：由于互联网相关服务具有特殊性，因本平台、相关第三方的设备系统维护；通讯故障、设备故障、电力中断、网络故障、黑客攻击、计算机病毒攻击及其他不可控制情况的影响，可能导致服务中断；</span
      >
    </p>
    <p>
      <span class="weight">
        （4）不可抗力风险：地震、台风、水灾、海啸、雷电、火灾、瘟疫、病毒、流行病、战争、恐怖主义、敌对行为、暴动、罢工、交通中断、经济形势严重恶化或其它类似事件导致的风险等。</span
      >
    </p>
    <p>
      <span class="weight">
        （5）操作风险：如果您缺乏必要的互联网经验，可能出现因操作不当导致损失；如果您未能谨慎保管自己的账号和密码，或者设置的密码简单导致密码被破解，以及您在进行资金交易时未能确保所使用的操作终端、网络以及周围环境的安全性，导致账号和密码被他人盗取、使用，可能导致违反您本人意愿的损失。由于本平台以账号和密码等要素进行身份识别，一切以您认证方式进行的操作等均被视为您本人的操作，您将对此发生的一切后果承担全部责任。</span
      >
    </p>
    <p><span class="weight">（6）其他不可归因于平台的风险。</span></p>
    <p>
      <span class="weight">
        2、除非另有书面协议约定，本平台在任何情况下（平台具备侵权的全部要素或者平台违约导致的除外），对用户使用本平台服务而产生的任何形式的直接或间接损失均不承担法律责任。</span
      >
    </p>
    <p>
      <span class="weight">
        3、基于平台业务，您与其他任何主体达成的任何约定以及产生的任何纠纷均由您自行负责，与本平台无关，本平台不承担任何责任。如由此给本平台、产品方造成的损失的，由您自行承担。</span
      >
    </p>
    <p>
      <span class="weight">
        4、任何本平台之外的第三方所提供的产品与服务，其产品品质及内容、纠纷由该第三方处理，与本平台无关。</span
      >
    </p>
    <p><span class="weight">第七条 网签协议的效力及有效期</span></p>
    <p>
      1、本平台提及的“网签协议”包括但不限于平台协议、平台发布的公告、声明、承诺、通知等文件。
    </p>
    <p>
      <span class="weight">
        2、您一旦点击确认或以类似方式同意了本平台的协议，即代表该文件即刻生效。您在此承诺不会以未阅读或未知晓该内容作任何形式的抗辩，也不得以未签署书面协议为由否认协议的效力。如在协议签署前，您对协议内容有任何异议请不要签署并停止使用该产品，否则，视为认可该协议的效力，后期不会以此为由否认其效力。</span
      >
    </p>
    <p>
      <span class="weight">
        3、平台发布的公告、声明、承诺、通知等法律文件也属于“网签协议”的范畴，如您对其内容有任何异议请停止使用该产品，否则，视为认可文件的效力，后期不会以此为由否认其效力。</span
      >
    </p>
    <p>
      4、本协议的有效期为自本协议签署之日至网签协议履行完毕，全部责任、义务履行完毕时，且平台账户注销之日止。
    </p>
    <p>
      <span class="weight">
        5、您同意本平台因为服务项目变更、公司业务变更或法律法规、监管要求、国家政策变更等原因修改本协议以及平台所有网签协议等，修改将以网页公告、电子邮件、站内信、短信等方式予以公告或通知，协议修改后您可以根据意愿选择是否同意，如不同意应停止使用本平台。如涉及用户权益方面条款的变动，您欲继续使用本服务的，请按照通告内容完成新协议的签约，或以其他类似方式确认同意新的内容。若您在本服务协议内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。</span
      >
    </p>
    <p>
      <span class="weight">
        如因业务模式的限制，导致无法立即终止使用本平台的，您同意届时认可上述协议的修改并履行完毕相应义务。</span
      >
    </p>
    <p>第八条 服务的变更</p>
    <p>
      <span class="weight">
        平台经营主体以及产品方有权对本服务协议及相应的服务规则内容进行变更，并将网页公告、电子邮件、站内信、短信等方式予以公告或通知；如您不同意该变更，可停止使用本服务。如涉及用户权益方面条款的变动，您欲继续使用本服务的，请按照通告内容完成新协议的签约，或以其他类似方式确认同意新的内容。若您在本服务协议内容变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的内容，也将遵循修改后的条款内容。</span
      >
    </p>
    <p>第九条 用户注销、暂停、终止或限制访问</p>
    <p>
      1、如您六个月内无用户账户操作且用户账户无余额，您的用户账户进入为期六个月的休眠期，休眠期结束后用户账户自动注销。休眠期内用户账户有任何操作或入账，用户账户正常使用。
    </p>
    <p>
      2、如果您决定不再使用本平台服务时，应首先完成所有义务，保证与相关方无任何争议以及遗留问题，并向本平台申请注销该账户，经本平台审核同意后方可正式注销您的账户。
    </p>
    <p>
      3、本平台有权基于单方独立判断，在认为可能发生危害交易安全等风险情形时，不经通知而先行暂停、中断或终止向您提供本协议项下的全部或部分用户服务，并将注册资料移除或删除，且无需对您或任何第三方承担任何责任。
    </p>
    <p>
      4、只要您利用本平台从事违法、违规活动或者违反本协议、其他网签协议的约定，本平台可在不发出任何通知的情况下立即限制您的访问、使您的账户无效，或撤销您的账户以及您的账户内的所有相关资料和档案，直接终止本协议。账号终止后，本平台没有义务为您保留原账号中任何信息，或转发任何未曾阅读或发送的信息给您或第三方。此外，本平台亦不会就终止您的账户使用而对您或任何第三者承担任何责任。
    </p>
    <p>
      5、您的账户的暂停、中断或终止不代表用户责任的终止，您仍应对其使用本平台提供服务期间的行为承担后续义务及相关的违约或损害赔偿责任，同时本平台有权永久存储相关信息。
    </p>
    <p>第十条 知识产权保护</p>
    <p>
      本平台所有内容和服务，包括但不限于平台的整体结构、网页设计、文字、图片、图表、软件、视频文件、音频文件、源代码、广告以及本平台为用户提供的其它信息或资料，以及支撑前述服务和内容的技术秘密与商业秘密，其知识产权均属本平台或相关权利方（如有）所有。未经本平台书面许可，任何人不得为了任何目的进行复制、变造、反向工程或者以其它方式进行非法使用。
    </p>
    <p>第十一条 赔偿</p>
    <p>
      1、因您违反本协议或其他网签协议，或违反了任何法律、法规的规定，给本平台造成损失的，应予赔偿，赔偿范围包括但不限于本平台的直接损失、间接损失以及维权费用（“维权费用”包括但不限于律师费、公证费、取证费、交通费、食宿费）。
    </p>
    <p>
      2、因您违反前款规定而侵害了第三方的权利，导致本平台遭受任何第三方提起的索赔、诉讼、仲裁或引发行政责任的，您承诺无条件承担相应责任并使本平台免责。若因此给本平台造成损失的，您应予赔偿，赔偿范围包括但不限于本平台的维权费用、名誉损失以及本平台向第三方支付的赔偿金、缴纳的行政罚金。
    </p>
    <p>第十二条 送达与信息变更</p>
    <p>
      1、您认可您提供给平台的信息即为有效的送达方式及送达地址，送达内容包括但不限于平台的通知、公函、权力机关的文书；送达方式包括但不限于公告（涉及隐私、秘密的除外）、站内信、短信、邮件、传真、邮寄。其中，公告、站内信、短信的送达方式，一经发出视为送达。
    </p>
    <p>
      2、用户如变更了提供给平台的信息，须及时通知本平台，否则仍视为有效的送达地址。因您未及时通知而导致自身、本平台及第三方受到的一切损失，由您自行承担，如因此给本平台造成损失的，本平台有权向您追偿。
    </p>
    <p>第十三条 争议的处理</p>
    <p>
      本协议在履行过程中，如发生任何争执或纠纷，双方应友好协商解决，协商不成的，任何一方有权向本公司所在地人民法院提起诉讼解决。
    </p>
    <p>第十四条 其他</p>
    <p>
      1、本协议中的任何条款或部分条款因违反中国法律而无效的，不影响本协议其他条款的效力。
    </p>
    <p>
      <span class="weight"
        >2、您同意本平台因为服务项目变更、公司业务变更或法律法规、监管要求、国家政策变更等原因修改本协议以及平台所有网签协议等，修改将以平台公告、短信通知、站内信等形式进行，协议修改后您可以根据意愿选择是否同意，如不同意应停止使用本平台，否则视为同意修改。如因业务模式的限制，导致无法立即终止使用本平台的，您同意届时认可上述协议的修改并履行完毕相应义务。</span
      >
    </p>
    <p>
      <span class="weight"
        >3、您作为本平台的用户，有义务随时关注本平台公示信息、通知、站内信、网签协议等，上述内容一经刊登、发送即生效，您不得以未阅读、未收到或未确认与签署为由否认其效力。</span
      >
    </p>
    <p>4、如有关内容其他网签协议未约定，适用本协议约定的相关内容。</p>
    <img src="../../assets/img/backPic.png" @click="back" class="pic" v-if="entryMode" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      entryMode: "", //判断是怎么进来的
    };
  },
  created() {
    document.title = "用户服务协议";
    let entryMode = this.$route.query.entryMode; //判断来源
    if (entryMode) {
      this.entryMode = entryMode;
    }
  },
  methods: {
    back() {
      if (this.entryMode == "backs") {
        this.$router.push({
          name: "registForRedEnvelopes",
          query: {
            isBack: "0000",
            commendCode: this.$route.query.commendCode,
            activeCode: this.$route.query.activeCode,
          },
        });
      } else {
        this.$router.push({
          name: "mxkShare",
          query: {
            isBack: "0000",
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.wrap {
  padding: 0 10px;
  padding-bottom: 20px;
}
.title {
  text-align: center;
  padding: 10px 0;
}
.weight {
  font-weight: bold;
}
p {
  line-height: 30px;
}
.subTitle {
  line-height: 28px;
  margin-top: 10px;
}
.pic {
  position: fixed;
  left: 0;
  bottom: 40%;
  opacity: 0.7;
}
</style>
